import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['Alle 10 kompletten Bände (Band 1–10).', 'Theorie, Beispiele und Aufgaben für jede Klassenstufe.', 'Schritt-für-Schritt-Aufbau, leicht verständlich.', 'Fertige Übungen für angeleitetes und selbstständiges Arbeiten.', 'Sofort einsatzbereit — zum Drucken oder digital am Bildschirm.', 'Druck so oft du willst — nie wieder Materialsorgen.'];
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-95" data-mp="1ref01yv6rbxb">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-96" data-mp="1rfzwxv4z36yc">
        <h2 className="mb-10 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-97" data-mp="25clpqrpze5lw">
          ⚡ Was bekommst du sofort?
        </h2>
        <ul className="space-y-4 rounded-3xl border border-brand-line bg-brand-main p-7 text-left shadow-sm md:p-10" data-id="element-98" data-mp="20ch6wv1loysi">
          {items.map(item => <li key={item} className="flex items-start gap-4" data-id="element-99" data-mp="61c8q69a9ekk">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange" data-id="element-100" data-mp="2n1osdqm2wsiw">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="2s1tbloedg1ct" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-102" data-mp="2wz2vypmwlmts">
                {item}
              </span>
            </li>)}
        </ul>
        <p className="mt-10 font-script text-2xl italic text-brand-orange" data-id="element-103" data-mp="35setb9s3a594">
          Dir geht nie das Material aus.
        </p>
      </Reveal>
    </section>;
}